import { render, staticRenderFns } from "./ZendeskModal.vue?vue&type=template&id=34865a1e"
import script from "./ZendeskModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ZendeskModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports